import React from "react";

//import PropTypes from 'prop-types';

export function CreateError(props) {
    const {} = props;
    return <div>CreateError</div>;
}

CreateError.propTypes = {};

CreateError.defaultProps = {};

export default CreateError;
